import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useQuery, useMutation, gql } from '@apollo/client';
import { Spinner } from 'equasion-lib';
import ApiError from '@/lib/shared-coms/ApiError';
import UnserializedReceiving from './UnserializedReceiving';
import { useRootStore } from '@/lib/providers/RootProvider';

const PURCHASE_ORDER = gql`
  query purchaseOrder($id: ID!, $clientId: ID!) {
    purchaseOrder(id: $id, clientId: $clientId) {
      id
      clientPurchaseOrderNumber
      orderItems {
        id
        productId
        quantity
        product {
          id
          title
          fdaProduct {
            id
            name
            elevenDigitNdc
            deaSchedule
          }
          upcProduct {
            id
            upc
          }
        }
      }
      vendor {
        id
        companyName
        locations {
          id
          type
          address {
            lineOne
            city
            state
          }
        }
      }
    }
  }
`;

const RECEIVE_UNSERIALIZED_PURCHASE_ORDER = gql`
  mutation receiveUnserializedPurchaseOrder(
    $id: ID!
    $orderItems: [OrderItemAttributes!]!
    $companyId: ID!
  ) {
    receiveUnserializedPurchaseOrder(
      id: $id
      orderItems: $orderItems
      companyId: $companyId
    ) {
      id
    }
  }
`;

function UnserializedReceivingData(props) {
  const clientId = useRootStore((state) => state.selectedCompany.id);
  const [receiveUnserializedPurchaseOrder] = useMutation(
    RECEIVE_UNSERIALIZED_PURCHASE_ORDER
  );
  const { purchaseOrderId } = useParams();
  const { data, error, loading, refetch } = useQuery(PURCHASE_ORDER, {
    variables: { id: purchaseOrderId, clientId: clientId }
  });

  if (loading) return <Spinner />;
  if (error) return <ApiError error={error} />;

  const { purchaseOrder } = data || {};

  return (
    <UnserializedReceiving
      purchaseOrder={purchaseOrder}
      receiveUnserializedPurchaseOrder={receiveUnserializedPurchaseOrder}
      refetch={refetch}
      {...props}
    />
  );
}

export default UnserializedReceivingData;
